import React from 'react';

const stats = [
  { value: '150+', label: 'Clients Served' },
  { value: '300+', label: 'Projects Delivered' },
  { value: '10+', label: 'Years Experience' },
  { value: '98%', label: 'Client Satisfaction' },
];

const Hero = () => {
  return (
    <section id="home" className="bg-gradient-to-br from-blue-900 via-primary to-secondary">
      <div className="max-w-7xl mx-auto px-4 py-28 text-center text-white">
        <span className="inline-block bg-white/10 border border-white/20 text-white text-sm font-semibold px-4 py-1 rounded-full mb-6 tracking-wide uppercase">
          North America's Trusted Technology Partner
        </span>
        <h1 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
          Accelerate Your Business<br />
          <span className="text-cyan-300">with Expert Consulting</span>
        </h1>
        <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-10">
          From Databricks data platforms to Microsoft Power Platform automation and cutting-edge AI solutions — Spiked Qcumber delivers end-to-end technology consulting across North America.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#services"
            className="bg-white text-primary px-8 py-3 rounded-full font-bold hover:bg-blue-50 transition-colors text-lg"
          >
            Explore Services
          </a>
          <a
            href="#contact"
            className="border-2 border-white text-white px-8 py-3 rounded-full font-bold hover:bg-white/10 transition-colors text-lg"
          >
            Book a Free Consultation
          </a>
        </div>
      </div>

      {/* Stats bar */}
      <div className="bg-white/10 backdrop-blur-sm border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-white">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="text-3xl font-extrabold text-cyan-300">{s.value}</div>
                <div className="text-sm text-blue-200 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
